<template>
  <div id="app">
    <component :is="layout">
      <router-view :key="$i18n.locale" />
    </component>
  </div>
</template>

<script>
export default {
  name: "App",
  components: {
    FullscreenLayout: () => import("@/layouts/FullscreenLayout.vue"),
    LendingLayout: () => import("@/layouts/LendingLayout.vue"),
  },
  computed: {
    layout() {
      return this.$route.meta.layout || "default-layout";
    },
  },
};
</script>
